import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

export default class QuestionDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div style={{ display: "flex" }}>
            {this.props.question
              ? languages.signupPage.editQuestion
              : languages.signupPage.addQuestion}
            <div style={{ flex: "1 1 10%" }} />
            {(this.props.tournament.lang || []).length > 1 && (
              <FormControl style={{ paddingRight: 9 }}>
                {/* <InputLabel htmlFor="reqOrOpt">
                  {languages.general.language}
                </InputLabel> */}
                <Select
                  value={this.props.lang || "0"}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "lang",
                    id: "lang",
                  }}
                >
                  <MenuItem value={"0"}>
                    {(this.props.tournament.lang || [])[0].toUpperCase()}
                  </MenuItem>
                  {(this.props.tournament.lang || []).slice(1).map((lang) => {
                    return (
                      <MenuItem key={lang} value={lang}>
                        {lang.toUpperCase()}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
          </div>
        </DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
          <DialogContentText />
          <TextField
            margin="dense"
            label={languages.signupPage.question}
            value={this.props.name}
            name="name"
            onChange={
              this.props.lang !== "0"
                ? this.props.handleTrsNameChange
                : this.props.handleChange
            }
            type="text"
            fullWidth
          />
          {(this.props.question || {}).id !== "0" &&
            (this.props.question || {}).id !== "1" &&
            (this.props.question || {}).id !== "2" &&
            (this.props.question || {}).id !== "3" &&
            (this.props.question || {}).id !== "4" && (
              <div>
                <FormControl
                  style={{ marginTop: 20, marginBottom: 5, width: "100%" }}
                >
                  <InputLabel htmlFor="reqOrOpt">
                    {languages.signupPage.requiredOrOptional}
                  </InputLabel>
                  <Select
                    value={this.props.reqOrOpt}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "reqOrOpt",
                      id: "reqOrOpt",
                    }}
                  >
                    <MenuItem value={"0"}>
                      {languages.signupPage.required}
                    </MenuItem>
                    <MenuItem value={"1"}>
                      {languages.signupPage.optional}
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{ marginTop: 20, marginBottom: 5, width: "100%" }}
                >
                  <InputLabel htmlFor="perSignup">
                    {languages.formatString(
                      languages.signupPage.perTeamOrSignup,
                      this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow
                    )}
                  </InputLabel>
                  <Select
                    value={this.props.perSignup || false}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "perSignup",
                      id: "perSignup",
                    }}
                  >
                    <MenuItem value={false}>
                      {languages.formatString(
                        languages.signupPage.perTeam,
                        this.props.tournament.individualPlayers
                          ? languages.teams.playerLow
                          : languages.results.teamLow
                      )}
                    </MenuItem>
                    <MenuItem value={true}>
                      {languages.signupPage.perSignup}
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  style={{ marginTop: 20, marginBottom: 5, width: "100%" }}
                >
                  <InputLabel htmlFor="bracket-size">
                    {languages.signupPage.type}
                  </InputLabel>
                  <Select
                    value={this.props.type}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "type",
                      id: "question-type",
                    }}
                  >
                    <MenuItem value={"0"}>
                      {languages.signupPage.textField}
                    </MenuItem>
                    <MenuItem value={"1"}>
                      {languages.signupPage.dropdown}
                    </MenuItem>
                  </Select>
                </FormControl>
                {this.props.type === "1" && (
                  <Typography variant="subtitle2" style={{ marginTop: 20 }}>
                    {languages.signupPage.choices}
                  </Typography>
                )}
                {this.props.type === "1" &&
                  Object.keys(this.props.choices)
                    .sort((a, b) => a - b)
                    .map((key, i) => {
                      let choice =
                        this.props.lang !== "0"
                          ? (this.props.trsChoices[this.props.lang] || {})[
                              key
                            ] || ""
                          : this.props.choices[key];
                      return (
                        <TextField
                          autoFocus
                          key={key}
                          margin="dense"
                          label={
                            languages.signupPage.choice +
                            " " +
                            (i + 1).toString()
                          }
                          value={choice}
                          name={key}
                          onChange={this.props.handleChoicesChange}
                          type="text"
                          fullWidth
                        />
                      );
                    })}
                {this.props.type === "1" && this.props.lang === "0" && (
                  <TextField
                    margin="dense"
                    label={
                      languages.signupPage.choice +
                      " " +
                      (Object.keys(this.props.choices).length + 1).toString()
                    }
                    value={""}
                    name={
                      Object.keys(this.props.choices).sort((a, b) => a - b)[
                        Object.keys(this.props.choices).length - 1
                      ]
                        ? (
                            Number(
                              Object.keys(this.props.choices).sort(
                                (a, b) => a - b
                              )[Object.keys(this.props.choices).length - 1]
                            ) + 1
                          ).toString()
                        : "0"
                    }
                    onChange={this.props.handleChoicesChange}
                    type="text"
                    fullWidth
                  />
                )}
              </div>
            )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            disabled={this.props.submitDisabled}
            variant="contained"
            color="primary"
            type="submit"
          >
            {this.props.question
              ? languages.general.save
              : languages.general.add}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
